module.exports = __webpack_public_path__ + "img/botonesAyuda.202faf69.png";